import { useState, useContext } from "react";
import AuthContext from "../../components/context/AuthContext";
import axios from "axios";
import ConfirmPrompt from "../../components/ui/prompts/ConfirmPrompt";
import FullScreenActivityIndicator from "../../components/ui/activityIndicator/FullScreenActivityIndicator";
import ImagePreviewPrompt from "../../components/ui/prompts/ImagePreviewPrompt";
import InfoPrompt from "../../components/ui/prompts/InfoPrompt";
import styles from "./EditPhotoPointPhotos.module.css";

const EditPhotos = ({ photos, refecthPhotosHandler }) => {
  const authCtx = useContext(AuthContext);
  const [confirmDeletePrompt, setConfirmDeletePrompt] = useState(false);
  const [loading, setLoading] = useState(null);
  const [preview, setPreview] = useState(null);
  const [responseStatus, setResponseStatus] = useState(null);
  const [status, setStatus] = useState(null);

  const resetInput = () => {
    setPreview(null);
    setConfirmDeletePrompt(false);
    setLoading(false);
  };

  // Check the response for valid parameters.
  const responseValid = (response) => {
    if (
      response == null ||
      response?.status == null ||
      response?.data == null
    ) {
      setStatus("Failed to delete photo.");
      resetInput();
      return false;
    }
    if (response.status !== 200) {
      setStatus(`Error: ${response.status} ${response.data}`);
      resetInput();
      return false;
    }
    return true;
  };

  // Update photos state using the response's data.
  const handleResponse = async (response) => {
    setResponseStatus(response?.data);
  };

  const deletePhotoHandler = () => {
    setPreview(null);
    setConfirmDeletePrompt(false);
    setLoading(true);
    let url = `${process.env.REACT_APP_API_URL}/photopoint/editVisibility`;
    let authObj = { headers: { Authorization: `token ${authCtx.token}` } };
    let obj = { attachmentID: preview.id, visibilityFlag: 0 };
    axios
      .post(url, obj, authObj)
      .then(async (response) => {
        if (!responseValid(response)) return;
        await handleResponse(response);
      })
      .catch((error) => {
        resetInput();
        setStatus(
          error?.response?.data
            ? `Error: ${error.response.data}`
            : `Error: ${error}`
        );
      });
  };

  const refetchPhotos = () => {
    resetInput();
    setResponseStatus(null);
    refecthPhotosHandler(true);
  };

  return (
    <>
      {photos && photos?.length > 0 && (
        <>
          <FullScreenActivityIndicator
            loading={loading}
            text="Deleting Photo..."
          />
          {photos && photos.length > 0 && (
            <div className={styles.photosDiv}>
              {photos.map((photo) => (
                <img
                  className={styles.photos}
                  key={photo.attachmentID}
                  alt="questionPhoto"
                  src={`data:image/png;base64, ${photo.image}`}
                  onClick={() =>
                    setPreview({
                      id: photo.attachmentID,
                      base64Key: `preview${photo.attachmentID}`,
                      base64Src: `data:image/png;base64, ${photo.image}`,
                    })
                  }
                />
              ))}
            </div>
          )}
        </>
      )}
      <ImagePreviewPrompt
        preview={preview}
        confirmHandler={() => setPreview(null)}
        setConfirmDeletePrompt={setConfirmDeletePrompt}
      />
      <ConfirmPrompt
        showPrompt={confirmDeletePrompt}
        text="Are you sure you want to delete this photo?"
        confirmHandler={deletePhotoHandler}
        rejectHandler={resetInput}
      />
      <InfoPrompt text={status} statusCleared={() => setStatus(null)} />
      <InfoPrompt text={responseStatus} statusCleared={refetchPhotos} />
    </>
  );
};

export default EditPhotos;
